module.exports = "<div class=\"ms__input ms__input_slider-range\"><div class=\"ms__range-slider\" range-slider=\"\" on-handle-up=\"afterChange()\" min=\"options.min\" max=\"options.max\" model-max=\"heightValue\" pin-handle=\"min\"></div></div><div class=\"ms__input ms__input_range\"><input class=\"input input_nano ms-input_border\" type=\"number\" min=\"0\" ng-model=\"heightValue\"/></div>";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./~/pug-html-loader/lib!./src/app/editor/modules_settings/height/template.jade
// module id = 334
// module chunks = 0